import { createWebHistory, createRouter } from "vue-router";
import authService from '../services/authService';

import WebsiteAnalyticsPage from "../components/Pages/WebsiteAnalyticsPage";
import HrManagementPage from "../components/Pages/HrManagementPage";
import LmsAcademyPage from "../components/Pages/LmsAcademyPage";
import CalendarPage from "../components/Pages/CalendarPage";
import ChatPage from "../components/Pages/ChatPage";
import MyDevicesPage from "../components/Pages/MyDevicesPage";
import RecentPage from "../components/Pages/RecentPage";
import ImportantPage from "../components/Pages/ImportantPage";
import DeleteFilesPage from "../components/Pages/DeleteFilesPage";
import DocumentsPage from "../components/Pages/DocumentsPage";
import ImagesPage from "../components/Pages/ImagesPage";
import VideosPage from "../components/Pages/VideosPage";
import AudioPage from "../components/Pages/AudioPage";
import ContactUsPage from "../components/Pages/ContactUsPage";
import InboxBoxPage from "../components/Pages/InboxBoxPage";
import StaredPage from "../components/Pages/StaredPage";
import DraftsPage from "../components/Pages/DraftsPage";
import ImpotentsPage from "../components/Pages/ImpotentsPage";
import TrashPage from "../components/Pages/TrashPage";
import LoginPage from "../components/Pages/LoginPage";
import RegisterPage from "../components/Pages/RegisterPage";
import ProfilePage from "../components/Pages/ProfilePage";
import EditProfilePage from "../components/Pages/EditProfilePage";
import ForgetPasswordPage from "../components/Pages/ForgetPasswordPage";
import ResetPasswordPage from "../components/Pages/ResetPasswordPage";
import ScreenLockPage from "../components/Pages/ScreenLockPage";
import ErrorPage from "../components/Pages/ErrorPage";
import BoxIconPage from "../components/Pages/BoxIconPage";
import RemixIconPage from "../components/Pages/RemixIconPage";
import AlertsPage from "../components/Pages/AlertsPage";
import ButtonsPage from "../components/Pages/ButtonsPage";
import ColorsPage from "../components/Pages/ColorsPage";
import AvatarSquarePage from "../components/Pages/AvatarSquarePage";
import AvatarRoundedPage from "../components/Pages/AvatarRoundedPage";
import AvatarRadiusPage from "../components/Pages/AvatarRadiusPage";
import DropDownsPage from "../components/Pages/DropDownsPage";
import ListGroupPage from "../components/Pages/ListGroupPage";
import TagsPage from "../components/Pages/TagsPage";
import PaginationPage from "../components/Pages/PaginationPage";
import NavigationPage from "../components/Pages/NavigationPage";
import TypographyPage from "../components/Pages/TypographyPage";
import BreadcrumbsPage from "../components/Pages/BreadcrumbsPage";
import BadgesPage from "../components/Pages/BadgesPage";
import PanelsPage from "../components/Pages/PanelsPage";
import ThumbnailsPage from "../components/Pages/ThumbnailsPage";
import MediaObjectPage from "../components/Pages/MediaObjectPage";
import AccordionPage from "../components/Pages/AccordionPage";
import TabsPage from "../components/Pages/TabsPage";
import ModalPage from "../components/Pages/ModalPage";
import ProgressBarPage from "../components/Pages/ProgressBarPage";
import CarouselPage from "../components/Pages/CarouselPage";
import DefaultTablePage from "../components/Pages/DefaultTablePage";
import DataTablePage from "../components/Pages/DataTablePage";
import DarkTablePage from "../components/Pages/DarkTablePage";
import GalleryPage from "../components/Pages/GalleryPage";
import AboutUsPage from "../components/Pages/AboutUsPage";
import ServicesPage from "../components/Pages/ServicesPage";
import TermsPage from "../components/Pages/TermsPage";
import InvoicePage from "../components/Pages/InvoicePage";
import PricingTablePage from "../components/Pages/PricingTablePage";
import EmptyPage from "../components/Pages/EmptyPage";
import ComingSoonPage from "../components/Pages/ComingSoonPage";
import BlogPage from "../components/Pages/BlogPage";
import BlogDetailsPage from "../components/Pages/BlogDetailsPage";
import MapPage from "../components/Pages/MapPage";
import WidgetsPage from "../components/Pages/WidgetsPage";
import CardDesignPage from "../components/Pages/CardDesignPage";
import NotificationsPage from "../components/Pages/NotificationsPage";
import ContentScrollBarPage from "../components/Pages/ContentScrollBarPage";
import LoadersPage from "../components/Pages/LoadersPage";
import CountersPage from "../components/Pages/CountersPage";
import RatingPage from "../components/Pages/RatingPage";
import TimelinePage from "../components/Pages/TimelinePage";
import TreeviewPage from "../components/Pages/TreeviewPage";
import FormLayoutsPage from "../components/Pages/FormLayoutsPage";
import InputGroupPage from "../components/Pages/InputGroupPage";
import FormEditorPage from "../components/Pages/FormEditorPage";
import FollowersPage from "../components/Pages/FollowersPage";
import FriendsPage from "../components/Pages/FriendsPage";
import ComposeMailPage from "../components/Pages/ComposeMailPage";
import ContactListPage from "../components/Pages/ContactListPage";
import AllFilesPage from "../components/Pages/AllFilesPage";
import ApexChartsPage from "../components/Pages/ApexChartsPage";
import GroupPage from "../components/Pages/GroupPage";
import NewsPage from "../components/Pages/NewsPage";
import ProjectsPage from "../components/Pages/ProjectsPage";
import DonationsPage from "../components/Pages/DonationsPage";
import InstitutionalPage from "../components/Pages/InstitutionalPage";
import MediaGalleryPage from "../components/Pages/MediaGalleryPage";
import CategoriesPage from "../components/Pages/CategoriesPage";
import OrganicStructurePage from "../components/Pages/OrganicStructurePage";
import FaqPage from "../components/Pages/FaqPage";
import VolunteersPage from "../components/Pages/VolunteersPage";

const routes = [
  { 
    path: "/", 
    name: "WebsiteAnalyticsPage", 
    component: WebsiteAnalyticsPage,
    meta: { title: "Home - GGMF Fundação", description: "Welcome to GGMF - Fundação. Helping the community through various projects and initiatives." }
  },
  {
    path: "/hr-management",
    name: "HrManagementPage",
    component: HrManagementPage,
  },
  { path: "/lms-academy", name: "LmsAcademyPage", component: LmsAcademyPage },
  { path: "/calendar", name: "CalendarPage", component: CalendarPage },
  { path: "/chat", name: "ChatPage", component: ChatPage },
  { path: "/my-devices", name: "MyDevicesPage", component: MyDevicesPage },
  { path: "/recent", name: "RecentPage", component: RecentPage },
  { path: "/important", name: "ImportantPage", component: ImportantPage },
  {
    path: "/deleted-files",
    name: "DeleteFilesPage",
    component: DeleteFilesPage,
  },
  { path: "/documents", name: "DocumentsPage", component: DocumentsPage },
  { path: "/images", name: "ImagesPage", component: ImagesPage },
  { path: "/videos", name: "VideosPage", component: VideosPage },
  { path: "/audio", name: "AudioPage", component: AudioPage },
  { path: "/contact-us", name: "ContactUsPage", component: ContactUsPage, meta: { title: "Contact Us - GGMF Fundação", description: "Get in touch with GGMF - Fundação. We are here to help and answer your questions." } },
  { path: "/inbox", name: "InboxBoxPage", component: InboxBoxPage },
  { path: "/starred", name: "StaredPage", component: StaredPage },
  { path: "/drafts", name: "DraftsPage", component: DraftsPage },
  { path: "/importants", name: "ImpotentsPage", component: ImpotentsPage },
  { path: "/trash", name: "TrashPage", component: TrashPage },
  { path: "/login", name: "LoginPage", component: LoginPage, meta: { public: true } },
  { path: "/register", name: "RegisterPage", component: RegisterPage, meta: { public: true } },
  { path: "/profile", name: "ProfilePage", component: ProfilePage },
  {
    path: "/edit-profile",
    name: "EditProfilePage",
    component: EditProfilePage,
  },
  {
    path: "/forget-password",
    name: "ForgetPasswordPage",
    component: ForgetPasswordPage,
    meta: { public: true },
  },
  {
    path: "/reset-password",
    name: "ResetPasswordPage",
    component: ResetPasswordPage,
    meta: { public: true },
  },
  { path: "/screen-lock", name: "ScreenLockPage", component: ScreenLockPage },
  { path: "/:pathMatch(.*)*", name: "ErrorPage", component: ErrorPage },
  { path: "/box-icon", name: "BoxIconPage", component: BoxIconPage },
  { path: "/remix-icon", name: "RemixIconPage", component: RemixIconPage },
  { path: "/alerts", name: "AlertsPage", component: AlertsPage },
  { path: "/buttons", name: "ButtonsPage", component: ButtonsPage },
  { path: "/colors", name: "ColorsPage", component: ColorsPage },
  {
    path: "/avatar-square",
    name: "AvatarSquarePage",
    component: AvatarSquarePage,
  },
  {
    path: "/avatar-rounded",
    name: "AvatarRoundedPage",
    component: AvatarRoundedPage,
  },
  {
    path: "/avatar-radius",
    name: "AvatarRadiusPage",
    component: AvatarRadiusPage,
  },
  { path: "/drop-downs", name: "DropDownsPage", component: DropDownsPage },
  { path: "/list", name: "ListGroupPage", component: ListGroupPage },
  { path: "/tags", name: "TagsPage", component: TagsPage },
  { path: "/pagination", name: "PaginationPage", component: PaginationPage },
  { path: "/navigation", name: "NavigationPage", component: NavigationPage },
  { path: "/typography", name: "TypographyPage", component: TypographyPage },
  { path: "/breadcrumbs", name: "BreadcrumbsPage", component: BreadcrumbsPage },
  { path: "/badges", name: "BadgesPage", component: BadgesPage },
  { path: "/panels", name: "PanelsPage", component: PanelsPage },
  { path: "/thumbnails", name: "ThumbnailsPage", component: ThumbnailsPage },
  {
    path: "/media-object",
    name: "MediaObjectPage",
    component: MediaObjectPage,
  },
  { path: "/accordion", name: "AccordionPage", component: AccordionPage },
  { path: "/tabs", name: "TabsPage", component: TabsPage },
  { path: "/modal", name: "ModalPage", component: ModalPage },
  { path: "/progress", name: "ProgressBarPage", component: ProgressBarPage },
  { path: "/carousel", name: "CarouselPage", component: CarouselPage },
  {
    path: "/default-table",
    name: "DefaultTablePage",
    component: DefaultTablePage,
  },
  { path: "/data-table", name: "DataTablePage", component: DataTablePage },
  { path: "/dark-table", name: "DarkTablePage", component: DarkTablePage },
  { path: "/gallery", name: "GalleryPage", component: GalleryPage },
  { path: "/about-company", name: "AboutUsPage", component: AboutUsPage, meta: { title: "About Us - GGMF Fundação", description: "Learn more about GGMF - Fundação, our mission, vision, and the team behind our projects." } },
  { path: "/services", name: "ServicesPage", component: ServicesPage, meta: { title: "Services - GGMF Fundação", description: "Explore the services and support GGMF - Fundação provides to the community." } },
  { path: "/terms", name: "TermsPage", component: TermsPage },
  { path: "/invoice", name: "InvoicePage", component: InvoicePage },
  {
    path: "/pricing-table",
    name: "PricingTablePage",
    component: PricingTablePage,
  },
  { path: "/empty", name: "EmptyPage", component: EmptyPage },
  { path: "/coming-soon", name: "ComingSoonPage", component: ComingSoonPage },
  { path: "/blog", name: "BlogPage", component: BlogPage, meta: { title: "Blog - GGMF Fundação", description: "Read our latest news, stories, and updates on the GGMF - Fundação blog." } },
  {
    path: "/blog-details",
    name: "BlogDetailsPage",
    component: BlogDetailsPage,
  },
  { path: "/map", name: "MapPage", component: MapPage },
  { path: "/widgets", name: "WidgetsPage", component: WidgetsPage },
  { path: "/cards-design", name: "CardDesignPage", component: CardDesignPage },
  {
    path: "/notifications",
    name: "NotificationsPage",
    component: NotificationsPage,
  },
  {
    path: "/content-scroll-bar",
    name: "ContentScrollBarPage",
    component: ContentScrollBarPage,
  },
  { path: "/loaders", name: "LoadersPage", component: LoadersPage },
  { path: "/counters", name: "CountersPage", component: CountersPage },
  { path: "/rating", name: "RatingPage", component: RatingPage },
  { path: "/timeline", name: "TimelinePage", component: TimelinePage },
  { path: "/treeview", name: "TreeviewPage", component: TreeviewPage },
  {
    path: "/form-layouts",
    name: "FormLayoutsPage",
    component: FormLayoutsPage,
  },
  { path: "/input-group", name: "InputGroupPage", component: InputGroupPage },
  { path: "/form-editor", name: "FormEditorPage", component: FormEditorPage },
  { path: "/followers", name: "FollowersPage", component: FollowersPage },
  { path: "/friends", name: "FriendsPage", component: FriendsPage },
  {
    path: "/compose-mail",
    name: "ComposeMailPage",
    component: ComposeMailPage,
  },
  {
    path: "/contact-list",
    name: "ContactListPage",
    component: ContactListPage,
  },
  { path: "/all-files", name: "AllFilesPage", component: AllFilesPage },
  { path: "/apexcharts", name: "ApexChartsPage", component: ApexChartsPage },
  { path: "/group", name: "GroupPage", component: GroupPage },
  // GGMF Management
  { path: "/noticias", name: "NewsPage", component: NewsPage, meta: { title: "News - GGMF Fundação", description: "Stay updated with the latest news and events from GGMF - Fundação." } },
  { path: "/projectos", name: "ProjectsPage", component: ProjectsPage, meta: { title: "Projects - GGMF Fundação", description: "Discover the impactful projects GGMF - Fundação is working on." } },
  { path: "/doacoes", name: "DonationsPage", component: DonationsPage, meta: { title: "Donations - GGMF Fundação", description: "Support GGMF - Fundação by making a donation. Every contribution helps us make a difference." } },
  { path: "/info-institucional", name: "InstitutionalPage", component: InstitutionalPage },
  { path: "/media-gallery", name: "MediaGalleryPage", component: MediaGalleryPage },
  { path: "/categorias", name: "CategoriesPage", component: CategoriesPage },
  { path: "/estrutura-organica", name: "OrganicStructurePage", component: OrganicStructurePage },
  { path: "/faqs", name: "FaqPage", component: FaqPage, meta: { title: "FAQ - GGMF Fundação", description: "Frequently Asked Questions about GGMF - Fundação and our work." } },
  { path: "/voluntarios", name: "VolunteersPage", component: VolunteersPage },
];

const router = createRouter({
  history: createWebHistory(),
  linkExactActiveClass: "active",
  routes,
  scrollBehavior() {
    return { top: 0, behavior: "smooth" };
  },
});

// Navigation guard: protege todas as rotas não públicas e gerencia SEO
router.beforeEach((to, _from, next) => {
  // Update Document Title
  const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
  const nearestWithDescription = to.matched.slice().reverse().find(r => r.meta && r.meta.description);
  
  if (nearestWithTitle) {
    document.title = nearestWithTitle.meta.title;
  }

  // Update Meta Description
  if (nearestWithDescription) {
    const descriptionTag = document.querySelector('meta[name="description"]');
    if (descriptionTag) {
      descriptionTag.setAttribute('content', nearestWithDescription.meta.description);
    }
  }

  const isPublic = to.meta?.public === true;
  const isAuthenticated = authService.isAuthenticated();

  if (!isPublic && !isAuthenticated) {
    // Rota protegida e sem sessão → redirecionar para login
    next({ name: 'LoginPage' });
  } else if (isPublic && isAuthenticated && (to.name === 'LoginPage' || to.name === 'RegisterPage')) {
    // Já autenticado e tenta ir para login/register → redirecionar para dashboard
    next({ path: '/' });
  } else {
    next();
  }
});

export default router;
